/* eslint semi: ["error", "never"]*/

/* eslint no-multi-spaces: ["error", { exceptions: { "ImportDeclaration": true,
                                       "VariableDeclarator": true  } }] */
import { FLASH_MESSAGE_CLEAR, FLASH_MESSAGE_SET } from '@engine/actions/action-types';
export var setFlashMessage = function setFlashMessage(data) {
  return {
    type: FLASH_MESSAGE_SET,
    data: data
  };
};
export var clearMessage = function clearMessage() {
  return {
    type: FLASH_MESSAGE_CLEAR
  };
};
export var clearFlashMessage = function clearFlashMessage() {
  return function (dispatch) {
    return dispatch(clearMessage());
  };
};